import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import produce from '@/components/produce'
import aboutUs from '@/components/aboutUs'
import recruitment from '@/components/recruitment'
import contactUs from '@/components/contactUs'
import legalNotice from '@/components/LegalNotice'

Vue.use(Router)

var router = new Router({
    linkActiveClass: 'active',
    scrollBehavior(to, from, savedPosition) {
        return {
            x: 0,
            y: 0
        }
    },
    routes: [{
            path: '/',
            name: '首页',
            component: index
        },
        {
            path: '/index',
            name: '首页',
            component: index
        }, {
            path: '/produce',
            name: '产品页(旗下游戏)',
            component: produce

        }, {
            path: '/aboutUs',
            name: '關於我們(公司介绍)',
            component: aboutUs
        }, {
            path: '/recruitment',
            name: '人才招聘',
            component: recruitment
        }, {
            path: '/contactUs',
            name: '聯係我們(商务合作)',
            component: contactUs
        }, {
            path: '/news',
            name: '资讯列表',
            component: () => import('@/components/news')
        }, {
            path: '/newsDetail/:id',
            name:'资讯详情',
            component: () => import('@/components/newsDetail')
        },{
            path: '/gamesDetail/:id',
            name:'资讯详情',
            component: () => import('@/components/gamesDetail')
        },{
            path: '/legalNotice',
            name: '法律声明',
            component: legalNotice
        }
    ]

})


export default router;